import React from "react";

const About = () => {
  return (
    <div className="about">
      <h1>
        ABOUT ME<span className="dot">.</span>
      </h1>
      <p>
        I am a creative and enthusiastic
        <br />
        <span className="span1">FULL STACK DEVELOPER</span>
        <br />
        slightly leaned towards <span className="span2">MERN Stack</span>,
        <br /> currently pursuing
        <br />
        <span className="span2">B. Tech in Computer Science.</span>
        <br />
        from Jaypee Institute of Information Technology, Noida.
        <br />I am also passionate about solving complex problems and
        enthusiastic towards <br />
        <span className="span1">competitive programming.</span>
        <br />
        Looking for an opportunity to utilize my skills in a challenging working
        environment to further develop my abilities in the fields of computer
        science and to become a valuable asset to the organisation that I work
        for.
      </p>
    </div>
  );
};

export default About;
